import React from 'react';

function ChartTooltip({ active, payload, label, entries, labelFormatter }) {
  if (!active || !payload || !payload.length) return null;

  const dateLabel = labelFormatter
    ? labelFormatter(label)
    : (() => {
        const date = new Date(label + 'T00:00:00');
        return date.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
      })();

  return (
    <div style={{ background: '#000', borderRadius: 8, padding: 12, minWidth: 140 }}>
      <p style={{ color: 'var(--sl-text-white, #fff)', fontSize: 12, margin: '0 0 8px 0' }}>{dateLabel}</p>
      {payload.map((entry, idx) => {
        const config = entries
          ? entries.find((e) => e.dataKey === entry.dataKey)
          : null;
        const entryLabel = config ? config.label : entry.dataKey;
        const format = config && config.format ? config.format : (v) => v.toLocaleString();
        return (
          <div key={idx} className="d-flex align-items-center" style={{ gap: 6, marginBottom: 4 }}>
            <span style={{ width: 8, height: 8, borderRadius: '50%', background: entry.color, flexShrink: 0 }} />
            <span style={{ color: '#a1a1aa', fontSize: 12 }}>{entryLabel}:</span>
            <span style={{ color: 'var(--sl-text-white, #fff)', fontSize: 12, fontWeight: 600 }}>{format(entry.value)}</span>
          </div>
        );
      })}
    </div>
  );
}

export default ChartTooltip;
